export const SUPPORTED_MICRO_PYTHON_STDLIB_MODULES = ['array', 'gc', 'math', 'struct', 'sys', 'time'] as const;

const SUPPORTED_MICRO_PYTHON_STDLIB_MODULE_SET = new Set<string>(SUPPORTED_MICRO_PYTHON_STDLIB_MODULES);

export function isSupportedMicroPythonStdlibModule(moduleName: string): boolean {
  return SUPPORTED_MICRO_PYTHON_STDLIB_MODULE_SET.has(moduleName);
}
